import React from "react"
import { Spinner } from "reactstrap"

const Spinners = ({
  color = "light",
  loadingText = "Please wait...",
  className = "align-items-center justify-content-center",
}) => {
  return (
    <React.Fragment>
      <div className={`d-flex ${className} `}>
        <span className="d-flex align-items-center justify-content-center me-2">
          <Spinner color={color} size={"sm"} />
        </span>{" "}
        {loadingText}
      </div>
    </React.Fragment>
  )
}

export default Spinners
